import { render, staticRenderFns } from "./SubmerchantNavigation.vue?vue&type=template&id=13498c08&"
import script from "./SubmerchantNavigation.vue?vue&type=script&lang=js&"
export * from "./SubmerchantNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports